import { OfficeTab } from '@root/globalTypes';
import { appRoutes, uuidRegEx } from '@utils/consts';
import { parseRoute } from '@utils/i18n';
import { kebabToCamelCase } from '@utils/textHelpers';
import { getJobsListUrl } from '@components/job/phoneBack/helpers';
import { BOTTOM_NAV_JOB_ROUTE_PREFIX } from '../bottomNav/constants';
import { NavbarPhoneTitle } from './types';

export const getNavbarPhoneTitle = (
  pathname: string,
  routes: string[],
): NavbarPhoneTitle | undefined => {
  const jobsRoute = `/${parseRoute(BOTTOM_NAV_JOB_ROUTE_PREFIX)}`;
  if (pathname.startsWith(jobsRoute) && routes.includes(appRoutes.jobs))
    return {
      tab: 'jobs',
      backTo: getJobsListUrl(`/${parseRoute(appRoutes.jobs)}`),
    };

  const route = routes.find(
    (el) => pathname === `/${parseRoute(el)}` || pathname.startsWith(`/${parseRoute(el)}/`),
  );
  if (!route) return undefined;

  const base = `/${parseRoute(route)}`;
  const [child] = pathname.slice(base.length + 1).split('/');
  return {
    tab: kebabToCamelCase(route) as OfficeTab,
    backTo: child && uuidRegEx.test(child) ? base : undefined,
  };
};
